<template>
  <b-row>
    <b-col cols="12">
      <branches />
    </b-col>
    <b-col cols="12">
      <user-types />
    </b-col>
    <b-col>
      <name-text />
    </b-col>
    <b-col>
      <email-text />
    </b-col>
    <b-col cols="12">
      <user-status />
    </b-col>
    <b-col cols="12">
      <password-text />
    </b-col>
    <b-col cols="12">
      <hr>
    </b-col>
    <b-col
      cols="12"
    >
      <b-button
        variant="primary"
        @click="saveData"
      >
        <FeatherIcon icon="SaveIcon" />
        Kaydet
      </b-button>
    </b-col>
  </b-row>
</template>
<script>
import {
  BRow, BCol, BButton,
} from 'bootstrap-vue'
import { localize } from 'vee-validate'
import { required } from '@validations'
import UserTypes from '@/views/Admin/Licenses/AppUsers/Elements/UserTypes.vue'
import Branches from '@/views/Admin/Licenses/AppUsers/Elements/Branches.vue'
import UserStatus from '@/views/Admin/Licenses/AppUsers/Elements/UserStatus.vue'
import NameText from '@/views/Admin/Licenses/AppUsers/Elements/NameText.vue'
import EmailText from '@/views/Admin/Licenses/AppUsers/Elements/EmailText.vue'
import PasswordText from '@/views/Admin/Licenses/AppUsers/Elements/PasswordText.vue'

export default {
  name: 'DrUserForm',
  components: {
    BRow,
    BCol,
    BButton,
    UserTypes,
    Branches,
    UserStatus,
    NameText,
    EmailText,
    PasswordText,
  },
  props: {
    saveData: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['drUsers/dataItem']
    },
  },
  created() {
    localize('tr')
  },
}
</script>
